const FINANCE_TABLES = new Set(['payments', 'customer-payments']);

export const MAX_ATOMIC_AUTOSAVE_SUPPRESSIONS = 256;

const suppressionQueues = new Map();

export function registerAtomicAutosaveSuppression(table, record) {
  if (!FINANCE_TABLES.has(table) || !record || typeof record !== 'object') return;
  let serialized;
  try {
    serialized = JSON.stringify(record);
  } catch {
    return;
  }
  const queue = suppressionQueues.get(table) || [];
  queue.push({ record, serialized });
  if (queue.length > MAX_ATOMIC_AUTOSAVE_SUPPRESSIONS) {
    queue.splice(0, queue.length - MAX_ATOMIC_AUTOSAVE_SUPPRESSIONS);
  }
  suppressionQueues.set(table, queue);
}

function parseBaseline(savedBaseline) {
  if (Array.isArray(savedBaseline)) {
    return {
      rows: savedBaseline,
      serialized: JSON.stringify(savedBaseline),
    };
  }
  if (typeof savedBaseline !== 'string') return null;
  try {
    const rows = JSON.parse(savedBaseline);
    return Array.isArray(rows)
      ? { rows, serialized: savedBaseline }
      : null;
  } catch {
    return null;
  }
}

function isAtomicOnlyState(rows, baselineRows, queue) {
  if (rows.length !== baselineRows.length) return false;
  let matchedToken = false;

  for (let index = 0; index < rows.length; index += 1) {
    const current = rows[index];
    const baseline = baselineRows[index];
    let currentSerialized;
    try {
      currentSerialized = JSON.stringify(current);
    } catch {
      return false;
    }
    const token = queue.find(
      (entry) => entry.record === current && entry.serialized === currentSerialized,
    );
    if (token) {
      if (!current || !baseline || current.id !== baseline.id) return false;
      matchedToken = true;
    } else if (currentSerialized !== JSON.stringify(baseline)) {
      return false;
    }
  }

  return matchedToken;
}

export function runAtomicAutosaveBaselineGate({
  table,
  rows,
  savedBaseline,
  lastSavedHash,
  onAtomicBaseline,
  onSave,
}) {
  const currentRows = Array.isArray(rows) ? rows : [];
  const serialized = JSON.stringify(currentRows);
  const queue = suppressionQueues.get(table);
  suppressionQueues.delete(table);
  const baseline = parseBaseline(savedBaseline);

  if (
    queue &&
    queue.length > 0 &&
    baseline &&
    isAtomicOnlyState(currentRows, baseline.rows, queue)
  ) {
    if (typeof onAtomicBaseline === 'function') onAtomicBaseline(serialized);
    return 'atomic_baseline';
  }
  if (
    serialized === (baseline?.serialized ?? null) ||
    serialized === (lastSavedHash || null)
  ) {
    return 'unchanged';
  }
  if (typeof onSave === 'function') onSave();
  return 'save';
}

export function _atomicAutosaveSuppressionCountForTests() {
  let count = 0;
  for (const queue of suppressionQueues.values()) count += queue.length;
  return count;
}

export function _resetAtomicAutosaveSuppressionsForTests() {
  suppressionQueues.clear();
}
